import PropTypes from 'prop-types';
import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';

import Calendar from "react-range-calendar";
import axios from "axios";

import { ReportingPageTabs } from './ReportingComponents/ReportingPageTabs.js';
import { fullDateFormat as dateFormatOptions } from './util/dateTime';



const DATE_FORMATS = ['DD.MM.YYYY', 'DD/MM/YYYY', 'DD/MM/YY', 'DDMMYY', 'D/M/YY'];

function formatDate(date) {
    try {
        return Intl.DateTimeFormat(navigator.language, dateFormatOptions).format(date).replace(/ /g, "\u00a0");
    } catch (e) {
        console.warn(`Cannot parse date ${date}`, e);
        return '';
    }
}

function formatServerDate(date) {
    function join(t, a, s) {
        function format(m) {
            let f = new Intl.DateTimeFormat('en', m);
            return f.format(t).padStart(2, '0');
        }
        return a.map(format).join(s);
    }
    
    let a = [{year: 'numeric'}, {month: 'numeric'}, {day: 'numeric'}];
    let s = join(date, a, '');
    return s;
}

const COLORS = [
    {
        'above': 3,
        'bg': 'rgba(255,99,132,1)',
        'bar': 'rgba(255, 99, 132, 0.2)'
    },
    {
        'above': 2.5,
        'bg': 'rgba(255, 159, 64, 0.2)',
        'bar': 'rgba(255, 159, 64, 1)'
    },
    {
        'above': 2,
        'bg': 'rgba(255, 206, 86, 0.2)',
        'bar': 'rgba(255, 206, 86, 1)'
    },
    {
        'above': 0,
        'bg': 'rgba(75, 255, 75, 0.2)',
        'bar': 'rgba(75, 255, 75, 1)'
    }
];

export class PuePage extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    pueResult = null;
    currentPue = null;

    state = {
        loading: true,
        error: null,
        data: [],
        currentPueDate: null,
        editing: false,
        editDate: new Date(),
        editValue: undefined,
        editSuccess: null,
        editError: null,
        pickingDateRange: false
    };

    static propTypes = {
        history: ReactRouterPropTypes.history.isRequired,
        location: ReactRouterPropTypes.location.isRequired,
        match: ReactRouterPropTypes.match.isRequired
    }

    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.pieChartRef = React.createRef();

        const now = new Date();

        this.state.timerange = [new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()), now];
    }

    UNSAFE_componentWillMount() {
        const self = this;

        import(/* webpackChunkName: "react-table-6" */ 'react-table-6').then(({ default: _ }) => {
            self.setState({
                ReactTable: _
            });
        });
        import(/* webpackChunkName: "chart-adapter.js" */ './chartjs-adapter-fullexport.js').then(({ default: _}) => {
            self.setState({
                Chart: _
            });
        });
    }

    componentDidMount() {
        const self = this;
        
        axios.get('/api/pue?get=true')
            .then(function (response) {
                let data = [];
                for (let item of response.data) {
                    const dateObj = new Date(item.t * 86400 * 1000);
                    data.push({ts: dateObj, date: formatDate(dateObj), v: item.v});
                }
                self.setState({data, loading: false});
            })
            .catch(function (error) {
                self.setState({error});
                console.error(error);
            });
        this.doPueCalc();
    }

    formatkWh(kWh) {
        let scale = 0;
        let trailing = 2;
        let unit = "kWh";

        if (kWh >= 1000000) {
            scale = 6;
            unit = "GWh";
        } else if (kWh >= 1000) {
            scale = 3;
            unit = "MWh";
        }

        if (kWh < 10) {
            // Use defaults
        } else if (kWh >= 10 && kWh < 100) {
            trailing = 1;
        } else if (kWh < 1000) {
            trailing = 0;
        } else if (kWh < 10000) {
            trailing = 2;
        } else if (kWh < 100000) {
            trailing = 1;
        } else if (kWh < 1000000) {
            trailing = 0;
        } else if (kWh < 10000000) {
            trailing = 2;
        } else if (kWh < 100000000) {
            trailing = 1;
        }

        const result = (kWh / Math.pow(10, scale)).toFixed(trailing) + " " + unit;
        return result;
    }

    getPieChartData() {
        const newVal = [this.currentPue.it, this.currentPue.total - this.currentPue.it];
        const labels = ["IT: " + this.formatkWh(newVal[0]), "Non-IT: " + this.formatkWh(newVal[1])];
        return {
            datasets: [
                {
                    data: newVal,
                    borderColor: ['rgba(75, 255, 75, 1)', 'rgba(255, 159, 64, 1)'],
                    backgroundColor: ['rgba(75, 255, 75, 0.2)', 'rgba(255, 159, 64, 0.2)']
                }
            ],
            labels: labels
        };
    }

    connectChart() {
        const self = this;

        if (this.chartRef.current && !this.chart && this.pueResult) {
            this.chart = new this.state.Chart(this.chartRef.current, {
                type: 'bar',
                data: {
                    datasets: [{
                        label: 'PUE',
                        data: this.pueResult,
                        backgroundColor: this.backgrounds,
                        borderColor: this.bars,
                        borderWidth: 1
                    }]
                },
                options: {
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                let label = data.datasets[tooltipItem.datasetIndex].label || '';

                                if (label) {
                                    label += ': ';
                                }
                                label += Math.round(tooltipItem.yLabel * 100) / 100;
                                return label;
                            }
                        }
                    },
                    scales: {
                        y: {
                            ticks: {
                                beginAtZero:true
                            }
                        },
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                distribution: 'series',
                                round: true
                            },
                            ticks: {
                                source: 'auto'
                            }
                        }
                    },
                    onClick: (ev, elements) => {
                        self.currentPue = self.rawPueResult[elements[0].index];
                        if (self.pieChart) {
                            self.pieChart.data = self.getPieChartData();
                            self.pieChart.update();
                        }
                        self.setState({currentPueDate: self.currentPue.date});
                    }
                }
            });
        }

        if (this.pieChartRef.current && !this.pieChart && this.currentPue) {
            this.pieChart = new this.state.Chart(this.pieChartRef.current, {
                type: 'doughnut',
                data: self.getPieChartData(),
                options: {
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                const dataSet = data.datasets[tooltipItem.datasetIndex];
                                return self.formatkWh(dataSet.data[tooltipItem.index]);
                            }
                        }
                    },
                }
            });
        }
    }

    doPueCalc() {
        const self = this;

        axios.get('/api/pue?startDate=' + formatServerDate(this.state.timerange[0]) + '&endDate=' + formatServerDate(this.state.timerange[1]))
            .then((response) => {
                if (self.pueResult) {
                    self.pueResult.length = 0;
                    self.backgrounds.length = 0;
                    self.bars.length = 0;
                } else {
                    self.pueResult = [];
                    self.backgrounds = [];
                    self.bars = [];
                }
                const ticks = self.pueResult;

                let currentItem = null;
                let rawResults = [];

                for (let ts in response.data) {
                    if (ts === "messages") {
                        continue;
                    }

                    const y = response.data[ts].value;

                    let colorFound = false;
                    for (let colorDef of COLORS) {
                        if (y >= colorDef.above) {
                            self.backgrounds.push(colorDef.bg);
                            self.bars.push(colorDef.bar);
                            colorFound = true;
                            break;
                        }
                    }

                    if (colorFound) {
                        const date = new Date(ts * 86400 * 1000);
                        ticks.push({x: date, y });
                        let rawResult = {...response.data[ts], date};
                        rawResults.push(rawResult);
                        if (!currentItem || date >= currentItem.date) {
                            currentItem = rawResult;
                        }
                    }
                }

                self.rawPueResult = rawResults;

                if (currentItem) {
                    self.currentPue = currentItem;

                    if (self.pieChart) {
                        self.pieChart.data = self.getPieChartData();
                        self.pieChart.update();
                    }

                    self.setState({currentPueDate: currentItem.date});
                }
                
                if (self.chart) {
                    self.chart.update();
                } else {
                    self.connectChart();
                }
            })
            .catch(error => {
                self.setState({error});
                console.error(error);
            });
    }

    onApplyAll = (filteredRows, ev) => {
        const self = this;

        this.setState((state) => {
            if (!state.acceptApplyAll) {
                return { acceptApplyAll: true, applyRunning: false };
            } else {
                self.runApplyAll(filteredRows, 0);
                return { applyRunning: true, acceptApplyAll: false, numToApply: filteredRows.length, applyIdx: 0 };
            }
        });

        ev.preventDefault();
    }

    onChangeValue = (e) => {
        this.setState({editValue: e.target.value});
    }

    onSubmitManual = (e) => {
        const self = this;
        if (!this.state.editValue || !this.state.editDate) {
            return;
        }

        const date = this.state.editDate;
        const value = this.state.editValue;

        axios.get('/api/pue?newPueAction=2&newValue=' + this.state.editValue + '&newDate=' + formatServerDate(this.state.editDate))
            .then(() => {
                self.setState((state) => {
                    let wasReplaced = false;
                    const newData = state.data.map((item) => {
                        if (item.date === date) {
                            wasReplaced = true;
                            return {
                                ...item, v: value
                            };
                        }
                        return item;
                    });
                    if (!wasReplaced) {
                        newData.push({ts:date, v:value, date: Intl.DateTimeFormat(navigator.language, dateFormatOptions).format(date) });
                    }

                    self.doPueCalc();

                    return { data: newData, editing: false, editValue: undefined, editSuccess: date };
                });
            }, (error) => {
                console.error(error);
                return { editError: error };
            });
    }

    disabledDate = (current) => {
        const now = new Date();
        const thisMorning = new Date(now);
        thisMorning.setUTCHours(0);
        thisMorning.setUTCMinutes(0);
        thisMorning.setUTCSeconds(0);
        return current > thisMorning;  // can not select days after today
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.timerange != this.state.timerange) {
            this.doPueCalc();
        }
    }

    render() {
        const self = this, t = this.context.t;

        if (!this.state.ReactTable || !this.state.Chart || this.state.loading) {
            return (
                <div className="wrapper devices">
                    <div className="loader-element">
                        <div className="loading loading-lg"></div>
                    </div>
                </div>
            );
        }

        // Translate all actions
        const pueActions = [];
        for (let i = 0; i <= 3; i++) {
            pueActions.push(t("pue.action_" + i));
        }

        const isValidDate = this.state.editDate;
        const isValidValue = this.state.editValue && !isNaN(parseFloat(this.state.editValue));
        let saveButton;
        if (!isValidDate) {
            saveButton = <button disabled={true} className="btn">{t("pue.select_date")}</button>
        } else if (!isValidValue) {
            saveButton = <button disabled={true} className="btn">{t("pue.enter_valid_amount")}</button>
        } else {
            saveButton = <button onClick={ this.onSubmitManual } className="btn btn-primary">{t("pue.save_amount")}</button>
        }

        let editEl = null;

        if (this.state.editing) {
            editEl = (
                <div className="column col-6 form-horizontal">
                    <h3>{ t('pue.title_manually_enter_value') }</h3>
                    <div className="form-group">
                        <div className="col-3 col-sm-12">
                            <label className="form-label" htmlFor="cal">{t('pue.select_date')}</label>
                        </div>
                        <div className="col-9 col-sm-12">
                            <Calendar
                                visible={true}
                                steps={7}
                                startWithDay={"Mon"}
                                dateRange={[this.state.editDate]}
                                onDateClick={(date) => {
                                    this.setState({ 
                                        editDate: date
                                    });
                                }}
                                type="single"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-3 col-sm-12">
                            <label className="form-label" htmlFor="cal">Enter total kWh.</label>
                        </div>
                        <div className="col-6 col-sm-6">
                            <input className="form-input" id="val" type="number" placeholder="27.1" onChange={this.onChangeValue} value={ this.state.editValue } />
                        </div>
                    </div>
                    <div className="col-12">
                        { saveButton }
                    </div>
                </div>
            );
        } else {
            editEl =
            (
                <div className="column col-6">
                    <button onClick={ e => self.setState({editing: true}) } className="btn btn-primary">{t("pue.button_enter_manual_total")}</button>
                </div>
            );
        }

        function isValidRange(v) {
            return v && v[0] && v[1];
        }


        const calendar = (

            <Calendar
                visible={this.state.pickingDateRange}
                steps={7}
                startWithDay={"Mon"}
                dateRange={this.state.timerange}
                onDateClick={(minDate, maxDate) => {
                    this.setState({ 
                        timerange: [minDate, maxDate],
                        pickingDateRange: false
                    });
                }}
                type="free-range"
            />
        );

        const columns = [
            {
                Header: t('general.date'),
                id: "date",
                accessor: "ts",
                Cell: row => {
                    return row.original.date;
                },
                filterMethod: (filter, row) => {
                    if (!filter.value) {
                        return true;
                    }
                    return row._original.date.indexOf(filter.value) !== -1;
                },
            }, {
                Header: t('general.value'),
                id: "v",
                accessor: "v"
            }
        ];


        return (
            <React.Fragment>
                <ReportingPageTabs location={this.props.location} />

                <div className="overview">
                    <div className="content">
                        <div className="columns">
                            <div className="pueChart column col-6 col-sm-12" >
                                {t('general.date')}: {formatDate(this.state.timerange[0])} - {formatDate(this.state.timerange[1])}
                                &nbsp;<button onClick={() => self.setState({'pickingDateRange': true})}>{t('general.edit')}</button>
                                { calendar }
                                <canvas ref={this.chartRef} id="pueChart" />
                            </div>
                            <div className="puePieChart column col-6 col-sm-12" >
                                <h4>
                                    { 
                                        this.state.currentPueDate ? 
                                            ("PUE " + formatDate(this.state.currentPueDate)) 
                                            : "" }
                                </h4>
                                <canvas ref={this.pieChartRef} id="puePieChart" />
                            </div>
                            <div className="column col-6 col-sm-12">
                                <h3>{ t('pue.title_manually_entered_values') }</h3>

                                <this.state.ReactTable
                                    data={this.state.data}
                                    columns={columns}
                                    onFilteredChange={(filtered) => self.setState({ currentFilter:filtered, acceptApplyAll: false }) }
                                    defaultPageSize={25}
                                    defaultSorted={[
                                        {
                                            id: "deviceName",
                                            desc: true
                                        }
                                    ]}
                                    filterable
                                    className="-striped -highlight"
                                />
                            </div>
                            { editEl }
                        </div>
                    </div>                    
                </div>




                
                <div className="overview__footer">
                    <a href="#">{t('general.return_to_top')}</a>
                </div>
            </React.Fragment>
        );

    }
}